import React, { useEffect } from 'react';
import { FormProvider, useFormContext, Controller } from 'react-hook-form';
import { useForm as useReactHookForm } from "react-hook-form";
import styled from 'styled-components';
import { ExplainIcon } from '../icons/ExplainIcon';
import { Flex } from './Flex';
import { Label, Paragraph, Title } from './Text';
import { FormTooltip } from './Tooltip';
import { Button } from './Button';

const StyledForm = styled.form.attrs({
    autocomplete: "off",
    noValidate: true
})`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background: #FFFFFF;

    & > div:not(:last-child) {
        margin-bottom: 18px;
    }
`;

const useForm = (defaultValues={}) => {
    return useReactHookForm({ defaultValues: defaultValues });
};

const Form = ({ form, onSubmit, onCancel, title, initialValues={}, watchFields, ...props }) => {
    let methods = useForm(initialValues);

    if (form) {
        methods = form;
    };

    return(
        <FormProvider {...methods}>
            <StyledForm
                onSubmit={methods.handleSubmit(onSubmit)}
            >
                {title && <Title h4 >{title}</Title>}
                <Flex direction="column">
                    {props.children}
                </Flex>
                <Flex justify="flex-end" align="center" gap={{ right: 12 }}>
                    <Button link type="button" onClick={() => onCancel()}>Cancel</Button>
                    <Button type="submit">Save</Button>
                </Flex>
            </StyledForm>
        </FormProvider>
    )
};

const FormItem = ({ label, validation={}, name, required, ...props }) => {
    const { control, unregister } = useFormContext();

    useEffect(() => {
        return () => unregister(name);
    }, []);

    return(
        <Controller
            control={control}
            name={name}
            rules={{ required: required, ...validation}}
            defaultValue=""
            render={({
                field,
                fieldState,
                formState
            }) => {
                let { error } = fieldState;
                if (error && error.type == "required" && !error.message) {
                    error.message = label ? label + " is required." : "Required field";
                }
                return (
                    <Flex direction="column" flex={1} margin={{ bottom: label ? "24px" : "6px"}}>
                        {label
                            ? <Flex align="center" gap={{ right: 4 }} margin={{ bottom: "4px"}}>
                                <Label htmlFor={name} required={required}>{label}</Label>
                                {error &&
                                    <FormTooltip text={error.message}>
                                        <ExplainIcon size={16} />
                                    </FormTooltip>}
                            </Flex>
                            : null}
                        {React.Children.toArray(props.children).map(child => React.cloneElement(child, { ...field, error: error != undefined }))}
                        {!label && <Paragraph color="var(--sp-danger-color)" style={{ height: "18px"}}>{error ? error.message : ""}</Paragraph>}
                    </Flex>
            )}}
        />
    )
};

Form.Item = FormItem;
Form.useForm = useForm;
export { Form };